import './App.css';
import Budget from './Budget';

function App() {
  return (
    <Budget />
  );
}

export default App;
